export default __webpack_public_path__ + "static/together-a593986f952c19e0e5050ac4efa4ae87.jpg";